export var ScopesPreset = /*#__PURE__*/function (ScopesPreset) {
  ScopesPreset["DEFAULT"] = "default";
  ScopesPreset["INTERNAL_NET"] = "internal-net";
  return ScopesPreset;
}({});
export var Status = /*#__PURE__*/function (Status) {
  Status[Status["IDLE"] = 0] = "IDLE";
  Status[Status["LOADING"] = 1] = "LOADING";
  Status[Status["FINISHED"] = 2] = "FINISHED";
  Status[Status["FAILED"] = 3] = "FAILED";
  return Status;
}({});
export var Layer = /*#__PURE__*/function (Layer) {
  Layer["WIKI"] = "wiki";
  Layer["PEOPLE"] = "people";
  Layer["GROUPS"] = "groups";
  Layer["ISSUES"] = "issues";
  Layer["DOC"] = "doc";
  Layer["ATUSHKA"] = "atushka";
  Layer["MAP"] = "map";
  Layer["ABC"] = "services";
  Layer["GOALS"] = "goals";
  Layer["CALENDAR"] = "calendar";
  Layer["ML"] = "ml";
  Layer["NPM"] = "npm";
  Layer["STACKOVERFLOW"] = "stackoverflow";
  Layer["HELP"] = "help";
  Layer["CHAT"] = "chat";
  return Layer;
}({});
export var Mark = /*#__PURE__*/function (Mark) {
  Mark["IRRELEVANT"] = "irrelevant";
  Mark["VITAL"] = "vital";
  return Mark;
}({});
export var Key = /*#__PURE__*/function (Key) {
  Key["ARROW_UP"] = "ArrowUp";
  Key["ARROW_DOWN"] = "ArrowDown";
  Key["ENTER"] = "Enter";
  Key["HOME"] = "Home";
  Key["END"] = "End";
  return Key;
}({});
export var MapEquipmentSubtype = /*#__PURE__*/function (MapEquipmentSubtype) {
  MapEquipmentSubtype["Printer"] = "printer";
  MapEquipmentSubtype["Scanner"] = "scanner";
  MapEquipmentSubtype["Copier"] = "copier";
  MapEquipmentSubtype["Mfp"] = "mfp";
  MapEquipmentSubtype["Dect"] = "dect";
  MapEquipmentSubtype["Wifi"] = "wifi";
  MapEquipmentSubtype["WifiPlatform"] = "wifi_mount_platform";
  MapEquipmentSubtype["Rj45"] = "rj45";
  MapEquipmentSubtype["Fax"] = "fax";
  MapEquipmentSubtype["Shredder"] = "shredder";
  MapEquipmentSubtype["Stationery"] = "stationery_cabinet";
  MapEquipmentSubtype["Hypercube"] = "hypercube";
  MapEquipmentSubtype["Sensor"] = "sensor";
  MapEquipmentSubtype["Zombie"] = "zombie";
  MapEquipmentSubtype["WifiSensor"] = "wifi_sensor";
  MapEquipmentSubtype["BendingMachine"] = "vending_machine";
  MapEquipmentSubtype["HelpMachine"] = "help_machine";
  MapEquipmentSubtype["Atm"] = "atm";
  MapEquipmentSubtype["MassageChair"] = "massage_chair";
  MapEquipmentSubtype["BatteryContainer"] = "battery_recycling_container";
  MapEquipmentSubtype["SleepCapsule"] = "sleep_capsule";
  MapEquipmentSubtype["PhotoBooth"] = "photo_booth";
  MapEquipmentSubtype["PhotoSpot"] = "photo_spot";
  return MapEquipmentSubtype;
}({});
export var MapRoomsSubtype = /*#__PURE__*/function (MapRoomsSubtype) {
  MapRoomsSubtype["Coffee"] = "coffee";
  MapRoomsSubtype["Wc"] = "wc";
  MapRoomsSubtype["Wardrobe"] = "wardrobe";
  MapRoomsSubtype["Shower"] = "shower";
  MapRoomsSubtype["Gym"] = "gym";
  MapRoomsSubtype["Library"] = "library";
  MapRoomsSubtype["Balcony"] = "balcony";
  MapRoomsSubtype["PhoneBooth"] = "phone_booth";
  MapRoomsSubtype["Smoking"] = "smoking";
  return MapRoomsSubtype;
}({});
export var Goal = /*#__PURE__*/function (Goal) {
  Goal["INTRASEARCH_SUGGEST_METRIKA_AB"] = "intrasearch_suggest_metrika_ab";
  Goal["INTRASEARCH_METRIKA_AB"] = "intrasearch_metrika_ab";
  return Goal;
}({});
// #sourceMappingURL=types.js.map